import axios from "axios";
import { API_BASE_URL, API_ENDPOINTS } from "../config/api";

export default class TenantService {
  tenantRegister(tenantData) {
    return axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.AUTH.TENANT_REGISTER}`,
      tenantData
    );
  }
  
  tenantLogin(tenantData) {
    return axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.AUTH.TENANT_LOGIN}`,
      tenantData
    );
  }
  
  doctorRegister(doctorData, token) {
    return axios.post(
      `${API_BASE_URL}${API_ENDPOINTS.AUTH.TENANT_REGISTER_DOCTOR}`,
      doctorData,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token'ı Authorization header'ında gönderiyoruz
        },
      }
    );
  }
  
  getAllDoctor = async (token) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.DOCTORS.TENANT_ALL}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Bearer token'ı Authorization header'ında gönderiyoruz
          },
        }
      );
      return response.data; // Veriyi döndürüyoruz
    } catch (error) {
      console.error("Doktorları çekerken hata oluştu:", error);
      throw error; // Hata fırlatarak çağıran fonksiyonun yakalamasını sağlıyoruz
    }
  };

  getTenantDoctorsList = async (token, options = {}) => {
    const response = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.DOCTORS.TENANT_ALL}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...(options.headers || {}),
        },
        params: {
          view: "list",
          ...(options.params || {}),
        },
      }
    );

    if (options.withMeta) {
      return { data: response.data, headers: response.headers };
    }
    return response.data;
  };

  exportTenantDoctorsExcel = async (token, filters = {}) => {
    return axios.get(API_ENDPOINTS.DOCTORS.TENANT_EXPORT_EXCEL, {
      baseURL: API_BASE_URL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: filters,
      responseType: "blob",
    });
  };
  
  getTenantInfo = async (tenantId, token) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.TENANTS.BY_ID(tenantId)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // token doğru şekilde header'a eklenmeli
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log("Bilgiler yüklenirken bir hata oluştu.");
      throw error;
    }
  };
  
  updateTenant = async (data, tenantId, token) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}${API_ENDPOINTS.TENANTS.UPDATE(tenantId)}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log("Bilgi değiştirme işlemi yapılırken bir hata oluştu.");
      throw error;
    }
  };
  
  getAllPatients = async (token) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.PATIENTS.TENANT_ALL}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log("Error");
    }
  };

  getTenantPatientsList = async (token, options = {}) => {
    const response = await axios.get(
      `${API_BASE_URL}${API_ENDPOINTS.PATIENTS.TENANT_ALL}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...(options.headers || {}),
        },
        params: {
          view: "list",
          ...(options.params || {}),
        },
      }
    );

    if (options.withMeta) {
      return { data: response.data, headers: response.headers };
    }
    return response.data;
  };

  exportTenantPatientsExcel = async (token, filters = {}) => {
    return axios.get(API_ENDPOINTS.PATIENTS.TENANT_EXPORT_EXCEL, {
      baseURL: API_BASE_URL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: filters,
      responseType: "blob",
    });
  };
  
  updateDoctorByTenant = async (doctorId, updateData, token) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}${API_ENDPOINTS.DOCTORS.TENANT_UPDATE(doctorId)}`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating doctor:", error);
      throw error;
    }
  };

  getDoctorInfo = async (doctorID, token) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.DOCTORS.TENANT_BY_ID(doctorID)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log("Sorun oluştu (getDoctorInfo)");
    }
  };
  
  getPatinetInfo = async (patientID, token) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${API_ENDPOINTS.TENANTS.PATIENT_BY_ID(patientID)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log("Sorun oluştu");
      throw error;
    }
  };
  
  deleteDoctor = async (data,token)=>{
    try{
      const response = await axios.delete(
        `${API_BASE_URL}${API_ENDPOINTS.DOCTORS.TENANT_DELETE(data)}`,
        {
          headers:{
            Authorization: `Bearer ${token}`
          }
        }
      )

    }catch(error){

    }
  }
  
  // 🆕 YENİ: Admin doktor davet etme (email ile + permission groups)
  inviteAdminDoctor = async (email, token, role_title, permissionGroupIds = null) => {
    try {
      const requestBody = { email, role_title };
      
      // Permission group IDs varsa ekle
      if (permissionGroupIds && Array.isArray(permissionGroupIds) && permissionGroupIds.length > 0) {
        requestBody.permissionGroupIds = permissionGroupIds;
      }
      
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.AUTH.TENANT_INVITE_ADMIN}`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Admin doktor daveti gönderilirken hata oluştu:", error);
      throw error;
    }
  }
  requestPasswordOtp = async (email) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.AUTH.PASSWORD_FORGOT}`,
        { email }
      );
      return response.data;
    } catch (error) {
      console.error("Şifre sıfırlama OTP isteğinde hata oluştu:", error);
      throw error;
    }
  };

  verifyPasswordOtp = async ({ email, otp }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.AUTH.PASSWORD_VERIFY_OTP}`,
        { email, otp }
      );
      return response.data;
    } catch (error) {
      console.error("OTP doğrulanırken hata oluştu:", error);
      throw error;
    }
  };

  resetPassword = async ({ resetToken, newPassword, confirmPassword }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}${API_ENDPOINTS.AUTH.PASSWORD_RESET}`,
        {
          resetToken,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Şifre sıfırlanırken hata oluştu:", error);
      throw error;
    }
  };
}
